import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { Navbar } from "reactstrap";
import { ITenant } from "../../app/models/tenant";
import { IUser } from "../../app/models/user";
import { RootStoreContext } from "../../app/stores/rootStore";
import { SpeakerLeaveButton } from "./SpeakerLeaveButton";

interface IParams {
  currentTenant: ITenant;
  user: IUser;
}

const PodiumNavbar: React.FC<IParams> = ({ currentTenant, user }) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;

  return (
    <>
      <Navbar
        className={classNames("p-0", theme!.headerColor)}
        expand="md"
        style={{ height: "40px" }}
      >
        <div
          className={classNames(
            "ml-2 navbarText text-truncate navbar-brand",
            theme!.headerTextColor
          )}
        ></div>

        <div className="ml-auto"></div>
        <SpeakerLeaveButton />
      </Navbar>
    </>
  );
};

export default observer(PodiumNavbar);
